import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ReassignDeclarationsParams {
  lrns: string;
  destinationBatchCounter: number;
}

export const useReassignDeclarations = () => {
  return useMutation({
    mutationFn: async ({ lrns, destinationBatchCounter }: ReassignDeclarationsParams) => {
      return request({
        path: 'admin/reassign-declarations',
        method: 'POST',
        authenticate: true,
        dataObject: { lrns, destinationBatchCounter },
      });
    },
    onSuccess: () => {
      toast.success('Declarations reassigned!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error reassigning declarations!');
    },
  });
};
